import React from 'react';
import { Box, Stack } from '@mui/material';
import appStoreBadge from '@assets/badges/app-store-es-mx.svg';
import googlePlayBadge from '@assets/badges/google-play-es-419.png';
import { APP_STORE_URL, Plataforma, PLAY_STORE_URL } from '@src/shared/utils/stores';

/** 40 px: los dos caben en una línea en un teléfono de 360 px de ancho. */
const BADGE_HEIGHT = 40;

const Badge: React.FC<{ href: string; src: string; alt: string }> = ({ href, src, alt }) => (
    <Box component="a" href={href} target="_blank" rel="noopener noreferrer" sx={{ display: 'block', lineHeight: 0 }}>
        <Box component="img" src={src} alt={alt} sx={{ height: BADGE_HEIGHT, width: 'auto' }} />
    </Box>
);

/** Los botones oficiales de las dos tiendas, en español; primero el del teléfono de la clienta. */
const StoreBadges: React.FC<{ plataforma: Plataforma; centrado?: boolean }> = ({ plataforma, centrado = true }) => {
    const apple = <Badge key="ios" href={APP_STORE_URL} src={appStoreBadge} alt="Descárgala en el App Store" />;
    const google = <Badge key="android" href={PLAY_STORE_URL} src={googlePlayBadge} alt="Disponible en Google Play" />;

    return (
        <Stack
            direction="row"
            spacing={1.25}
            justifyContent={centrado ? 'center' : 'flex-start'}
            flexWrap="wrap"
            useFlexGap
        >
            {plataforma === 'android' ? [google, apple] : [apple, google]}
        </Stack>
    );
};

export default StoreBadges;
